import type { ReactNode } from "react"
import Logo from "@rawa/ui/assets/logo.svg?react"
import styles from "./FeedbackLayout.module.scss"

export function FeedbackLayout({ children }: { children: ReactNode }) {
  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <Logo
          role="img"
          className={styles.logo}
          aria-label="Relationships Australia WA"
        />
      </header>
      <main className={styles.main}>{children}</main>
    </div>
  )
}
